<template>
<div class='wait-content'>
    <crumb></crumb>

</div>
</template>

<script>
import crumb from '../components/crumb'
export default {
components: {
    crumb
},
data() {
return {

};
},
computed: {},
watch: {},
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
methods: {

},            
}
</script>
<style lang='scss' scoped>

</style>